import { Pagination } from '@components/Pagination'
import { Table } from '@components/Table'

import { columns } from './column'
import { AdjustCoinStatusTableProps } from './interface'

export function AdjustCoinStatusTable({
  data,
  isLoading,
  page,
  perpage,
  total,
  searchParam,
  handleSort,
  pageChange,
  refetch,
}: AdjustCoinStatusTableProps) {
  return (
    <div>
      <div className='flex items-center mb-[10px]'>
        <span className='text-secondary-100 text-[12px] font-light'>
          {`ข้อมูลทั้งหมด : ${total.toLocaleString()}`}
        </span>
      </div>
      <div className='flex-1 overflow-x-auto pb-[20px]'>
        <Table
          data={data}
          columns={columns({ refetchGetCoinToAdjustHistories: refetch })}
          onSort={handleSort}
          isLoading={isLoading}
          initialSort={{
            key: searchParam.sortKey,
            order: searchParam.sortOrder,
          }}
          className='w-[1450px]'
          headerClassName='border-x-[1px] border-y-[1px] border-gray text-secondary-100 text-[12px] font-bold'
        />
      </div>
      <div className='mt-[10px]'>
        <Pagination
          page={page}
          perpage={perpage}
          total={total}
          pageChange={pageChange}
        />
      </div>
    </div>
  )
}
